import React from 'react';
import styled from 'styled-components'
import { AdSlot } from 'react-dfp';
import LazyLoad from 'react-lazyload';

const css = `
  width: 320px; min-height: 50px;
  @media(min-width: 780px) { width: 728px; height: 90px; }
  margin-left: auto;
  margin-right: auto;
`;
const Elem = styled(AdSlot)([css]);
const PlaceHolder = styled.div([css]);

export default function UstBannerAd(props) {
  return <React.Fragment>
    <LazyLoad offset={500} placeholder={<PlaceHolder />} >
      <Elem sizes={[[320,50], [728, 90]]} 
         sizeMapping={[ 
          {viewport: [780, 480], sizes: [[728, 90], [468, 60]]}, 
          {viewport: [0, 0], sizes: [[320, 50]]} ]} 
        adUnit={props.id || "gastearsivi-leaderboard-1"} />
    </LazyLoad>
  </React.Fragment>
}
